module.exports = __webpack_public_path__ + "a7bc5e58cb682dacf304e04adfe564ba.svg";